import { render, staticRenderFns } from "./client-details-sub.vue?vue&type=template&id=59cd6e3c&scoped=true"
import script from "./client-details-sub.vue?vue&type=script&lang=js"
export * from "./client-details-sub.vue?vue&type=script&lang=js"
import style0 from "./client-details-sub.vue?vue&type=style&index=0&id=59cd6e3c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59cd6e3c",
  null
  
)

export default component.exports